function F() {
  return false
}

function identity(x) {
  return x
}

function not(x) {
  return !x
}

function _reduce(halt, fn, y, xs) {
  let result = y
  for (const x of xs) {
    if (halt(result)) {
      return result
    }
    result = fn(result, x)
  }
  return result
}

export function all(fn, xs) {
  return _reduce(not, (_, x) => fn(x), true, xs)
}

export function any(fn, xs) {
  return _reduce(identity, (_, x) => fn(x), false, xs)
}

export function map(fn, xs) {
  return reduce((ys, x) => ys.concat([fn(x)]), [], xs)
}

export function reduce(fn, y, xs) {
  return _reduce(F, fn, y, xs)
}

export function get(fallback, path, obj) {
  return _reduce(
    result => result == null,
    (result, key) => {
      if (fallback instanceof Error) {
        if (!result.hasOwnProperty(key)) {
          throw fallback
        }
      }

      return result.hasOwnProperty(key) ? result[key] : fallback
    },
    obj,
    path
  )
}

export function filter(fn, xs) {
  return reduce(
    (ys, x) => fn(x) ? ys.concat([x]) : ys,
    [],
    xs
  )
}

export function reject(fn, xs) {
  return reduce(
    (ys, x) => fn(x) ? ys : ys.concat([x]),
    [],
    xs
  )
}

export function isEmptyArray(xs) {
  return xs.length === 0
}

export function unnest(xs) {
  return reduce(
    (ys, x) => ys.concat(Array.isArray(x) ? x : [x]),
    [],
    xs
  )
}
